import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenshotService {

  /**
   * Capture a screenshot of the current page using html2canvas.
   * Returns a base64-encoded PNG string (without data:image/png;base64, prefix).
   */
  async captureScreenshot(): Promise<string> {
    try {
      // Dynamic import to avoid loading html2canvas until needed
      const html2canvas = (await import('html2canvas')).default;

      const canvas = await html2canvas(document.body, {
        useCORS: true,
        allowTaint: false,
        scale: 1, // 1x scale for reasonable file size (~200-500KB)
        logging: false,
        backgroundColor: '#ffffff',
        ignoreElements: (element: Element) => {
          // Skip modals and overlays that would obstruct the view
          return element.classList?.contains('modal-backdrop') ||
                 element.classList?.contains('cdk-overlay-container');
        }
      });

      // Convert to base64 PNG, strip the data URL prefix
      const dataUrl = canvas.toDataURL('image/png', 0.85);
      return dataUrl.replace(/^data:image\/png;base64,/, '');
    } catch (error) {
      console.error('Screenshot capture failed:', error);
      throw new Error('Kunne ikke ta skjermbilde. Prøv igjen.');
    }
  }

  /**
   * Get the base64 data URL (with prefix) for display in an <img> tag.
   */
  toDataUrl(base64: string): string {
    return `data:image/png;base64,${base64}`;
  }
}
